import { CARD_ICON_COMPONENTS } from './cardIcons'
import type { CardIconKey } from './cardIcons'
import { StampCircle } from './StampCircle'
import { StampGrid } from './StampGrid'
import type { StampState } from './StampCircle'

interface MilestoneIcon {
  stampPosition: number
  cardIcon: CardIconKey
}

interface MilestoneStampGridProps {
  current: number
  total: number
  completionCardIcon: CardIconKey
  milestones: MilestoneIcon[]
  stampSize?: number
  gap?: number
  maxGap?: number
  justify?: 'flex-start' | 'center'
  previewCount?: number
  removingCount?: number
  accessibilityLabels?: Partial<Record<StampState, string>>
}

export function MilestoneStampGrid({
  current,
  total,
  completionCardIcon,
  milestones,
  stampSize = 44,
  gap,
  maxGap,
  justify,
  previewCount = 0,
  removingCount = 0,
  accessibilityLabels,
}: MilestoneStampGridProps) {
  function iconForPosition(position: number) {
    if (position === total) return CARD_ICON_COMPONENTS[completionCardIcon]
    const milestone = milestones.find((m) => m.stampPosition === position)
    return milestone ? CARD_ICON_COMPONENTS[milestone.cardIcon] : undefined
  }

  const renderStamp = (i: number) => {
    const state: StampState =
      removingCount > 0 && i >= current - removingCount && i < current ? 'removing' :
      i < current ? 'filled' :
      i < current + previewCount ? 'preview' :
      'empty'

    return (
      <StampCircle
        key={i}
        state={state}
        size={stampSize}
        icon={iconForPosition(i + 1)}
        accessibilityLabel={accessibilityLabels?.[state]}
      />
    )
  }

  return (
    <StampGrid count={total} stampSize={stampSize} renderStamp={renderStamp} gap={gap} maxGap={maxGap} justify={justify} />
  )
}
